import Flyer from './flyer';
import Sticker from './sticker';
import DoorSticker from './door-sticker';

export default {
  Flyer,
  DoorSticker,
  Sticker,
};
